<div *ngIf="type==='warning' || type === 'danger' || type === 'success'"
     class="{{type}} mb-4 d-flex align-items-center noticeBox">
  <sb-icon *ngIf="type=== 'warning'" icon="attention" class="mx-2" style="font-size: 1.5rem"></sb-icon>
  <sb-icon *ngIf="type=== 'danger'" icon="error" class="mx-2" style="font-size: 1.5rem"></sb-icon>
  <sb-icon *ngIf="type=== 'success'" icon="thumbsUp" class="mx-2" style="font-size: 1.5rem"></sb-icon>
  <div>
    <ng-content>

    </ng-content>
  </div>
</div>
<!--
<div *ngIf="!(type==='warning' || type === 'danger' || type === 'success')" class="danger mb-4 d-flex align-items-center noticeBox">
{{'lang.globals.error'|translate}}
</div>
-->
